/**
 * Devuelve dos arrays, el primero con las cadenas, el segundo con las expresiones.
 * Siempre el primero sera de las cadenas, si el string empieza por na expression, la primera cadena sera "".
 *
 * @example 'una cadena ${una expression} fin.' -> ['una cadena ', ' fin.'], ['una expression']
 * @example 'S{empiezo con expression} fin.' -> ['', ' fin.'], ['empiezo con expression']
 *
 * @param {string} str un string normal con formato de string literal
 */
export function tokenizer(str) {
  if (typeof str !== 'string') {
    throw new TypeError('argument must be a string');
  }
  const strings = [];
  const expressions = [];
  let cur = '';
  let isExpression = false;
  let openedBracket = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const letter = str[i];

    if (isExpression) {
      if (letter === '{') {
        openedBracket++;
        cur += letter;
      } else if (letter === '}') {
        openedBracket--;
        if (openedBracket === 0) {
          expressions.push(cur);
          cur = '';
          isExpression = false;
        } else {
          cur += letter;
        }
      } else {
        cur += letter;
      }
    } else {
      if (letter === '$' && str[i + 1] && str[i + 1] === '{') {
        isExpression = true;
        strings.push(cur);
        cur = '';
        openedBracket = 1;
        i++;
      } else {
        cur += letter;
      }
    }
  }
  if (openedBracket !== 0) {
    throw new Error(`strangerthings, ${openedBracket} "}" are missing...`);
  }
  if (cur) {
    strings.push(cur);
  }

  return [strings, expressions];
}
